const CREATORS_ACCORDION_TAB_TYPES = ['creator', 'iconic design', 'seller-maker'];

export const isCreatorsAccordionTab = (tabType: string | null | undefined): boolean =>
    typeof tabType === 'string' && CREATORS_ACCORDION_TAB_TYPES.includes(tabType);
